/** Retenção e paginação da Price Activity (configurável). */

/** Manter alterações dos últimos N dias. */
export const PRICE_ACTIVITY_RETENTION_DAYS = 30;

/** Teto por categoria após o trim temporal. */
export const PRICE_ACTIVITY_MAX_PER_CATEGORY = 50;

/** Itens iniciais / por página no modal. */
export const PRICE_ACTIVITY_MODAL_PAGE_SIZE = 10;
